import { createSlice } from "@reduxjs/toolkit";

import { getSourcesTypesRedux } from "./sourcesTypes.asyncActions";

const initialState = {
    sources: [],
    status: "idle",
};

export const sourcesTypesSlice = createSlice({
    name: "allSourcesTypesState",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getSourcesTypesRedux.pending, (state) => {
                state.status = "loading";
            })
            .addCase(getSourcesTypesRedux.fulfilled, (state, action) => {
                state.status = "idle";
                state.sources = action.payload.data[0] && action.payload.data[0];
            })
            .addCase(getSourcesTypesRedux.rejected, (state, action) => {
                state.status = "failed";
            });
    },
});

export default sourcesTypesSlice.reducer;
